export default __webpack_public_path__ + "static/media/ICON3.65bfa1c5.svg";